module.exports = __webpack_public_path__ + "static/img/22.b69258d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/22.jpg
// module id = lPMd
// module chunks = 1